import { SubscriptionService } from "@/services/subscription.service";
import { assign, pick } from "lodash";
import Vue from "vue";

export default {
  namespaced: true,
  state: {
    subscriptions: [],
    subscriptionUrl: null,
    _subscriptionUrlPromise: null,
    // Muda a cada RESET (sessão desfeita): o link de um aluno que chega depois
    // do reset não fica em cache para o próximo.
    _generation: 0,
  },
  actions: {
    getUserSubscriptions({ commit, state }) {
      const generation = state._generation;
      return SubscriptionService.getUserSubscriptions()
        .then((response) => {
          if (generation === state._generation) commit("SET_SUBSCRIPTIONS", response.data);
        })
        .catch((error) => {
          commit(
            "toast/NEW",
            { type: "error", message: error.message, suppressOffline: true },
            { root: true }
          );
        });
    },
    generateSubscriptionUrl({ commit, state }) {
      if (state.subscriptionUrl) return Promise.resolve();
      if (state._subscriptionUrlPromise) return state._subscriptionUrlPromise;
      const generation = state._generation;
      const promise = SubscriptionService.generateToken()
        .then((response) => {
          if (generation !== state._generation) return undefined;
          if (response.data) commit("SET_SUBSCRIPTION_URL", response.data.url);
          return response;
        })
        .catch(() => {})
        .finally(() => {
          if (generation === state._generation) commit("SET_SUBSCRIPTION_URL_PROMISE", null);
        });
      commit("SET_SUBSCRIPTION_URL_PROMISE", promise);
      return promise;
    },
    cancelSubscription({ commit }, { subscriptionId }) {
      return SubscriptionService.cancelSubscription(subscriptionId)
        .then((response) => {
          commit("UPDATE_SUBSCRIPTION", {
            subscriptionId,
            payload: {
              status: "Cancelamento Pendente",
            },
          });
        })
        .catch((error) => {
          commit(
            "toast/NEW",
            { type: "error", message: error.message, suppressOffline: true },
            { root: true }
          );
        });
    },
  },
  mutations: {
    SET_SUBSCRIPTIONS(state, data) {
      state.subscriptions = data;
    },
    SET_SUBSCRIPTION_URL(state, url) {
      state.subscriptionUrl = url;
    },
    SET_SUBSCRIPTION_URL_PROMISE(state, promise) {
      state._subscriptionUrlPromise = promise;
    },
    // Sessão desfeita (logout, sessão expirada): o link de "Minhas assinaturas"
    // leva o hash do CLIENTE e o clearToLogin não recarrega a página, então
    // sem isto o próximo aluno no mesmo aparelho abriria o do anterior (menu ou
    // push de assinatura em atraso, STORY-1642).
    RESET(state) {
      state.subscriptions = [];
      state.subscriptionUrl = null;
      state._subscriptionUrlPromise = null;
      state._generation += 1;
    },
    UPDATE_SUBSCRIPTION(state, data) {
      const subscriptionIndex = state.subscriptions.findIndex(
        (subscription) => subscription.id === data.subscriptionId
      );

      if (subscriptionIndex === -1) return;

      const update = assign(
        {},
        state.subscriptions[subscriptionIndex],
        pick(data.payload, Object.keys(state.subscriptions[subscriptionIndex]))
      );

      Vue.set(state.subscriptions, subscriptionIndex, {
        ...state.subscriptions[subscriptionIndex],
        ...update,
      });
    },
  },
};
